import * as React from 'react';
import { Path, Svg } from 'react-native-svg';

import { withDefaultIconProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const Dot = withDefaultIconProps(
  {
    height: 5,
    width: 5,
    color: theme.colors['text.primary'],
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 5 5">
      <Path
        d="M2.6 4.4C3.82 4.4 4.8 3.42 4.8 2.2C4.8 0.98 3.82 0 2.6 0C1.38 0 0.4 0.98 0.4 2.2C0.4 3.42 1.38 4.4 2.6 4.4Z"
        fill={color}
      />
    </Svg>
  ),
);
export default Dot;
